/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ccsl_Export_Header_Continuity_DialogueInputs */



/**
* | output |
* | --- |
* | "CONTINUITY/DIALOGUE" |
*
* @param {Ccsl_Export_Header_Continuity_DialogueInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const ccsl_export_header_continuity_dialogue = /** @type {((inputs?: Ccsl_Export_Header_Continuity_DialogueInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ccsl_Export_Header_Continuity_DialogueInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("CONTINUITE/DIALOGUE")
	if (locale === "de") return /** @type {LocalizedString} */ ("KONTINUITÄT/DIALOG")
	if (locale === "it") return /** @type {LocalizedString} */ ("CONTINUITÀ/DIALOGO")
	if (locale === "ru") return /** @type {LocalizedString} */ ("НЕПРЕРЫВНОСТЬ/ДИАЛОГ")
	if (locale === "es") return /** @type {LocalizedString} */ ("CONTINUIDAD/DIÁLOGO")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("连续性/对话")
	if (locale === "ja") return /** @type {LocalizedString} */ ("連続性/対話")
	if (locale === "hi") return /** @type {LocalizedString} */ ("निरंतरता/संवाद")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("CONTINUIDADE/DIÁLOGO")
	return /** @type {LocalizedString} */ ("CONTINUITY/DIALOGUE")
});